// components
import { IconComponent } from '@centria-ui-atoms/icon-component'
import { Typography } from '@centria-ui-atoms/typography'

// prime components
import { MultiStateCheckbox as PrMultiStateCheckbox } from 'primereact/multistatecheckbox'

// styles
import classes from './styles.module.scss'

// type
import type { MultiStateCheckboxProps as PrMultiStateCheckboxProps } from 'primereact/multistatecheckbox'
import type { IconName } from '@centria-ui-atoms/icon-component'
import type { FC } from 'react'

interface MultiStateCheckboxProps
  extends Omit<PrMultiStateCheckboxProps, 'options'> {
  textDefault: string
  options: { value: string; icon: IconName }[]
}

export const MultiStateCheckbox: FC<MultiStateCheckboxProps> = ({
  value,
  textDefault,
  ...props
}) => {
  return (
    <div className='d-flex gap-2'>
      <Typography Tag='label' fontSize='small'>
        {value || textDefault}
      </Typography>
      <PrMultiStateCheckbox
        {...props}
        value={value}
        optionValue='value'
        className={classes.checkbox}
        iconTemplate={(ev) =>
          ev.option?.icon ? (
            <IconComponent color='white' icon={ev.option.icon as IconName} />
          ) : null
        }
      />
    </div>
  )
}
